SV = window.SV || {};

SV.HoverIntent = (function() {

  // constructor
  return function(elements, userConfig) {

    // private members

    const defaultOptions = {
      exitDelay: 400,
      interval: 100,
      sensitivity: 7,
    };
    let config = {};

    let currX, currY, prevX, prevY;
    let allElems, pollTimer, exitTimer;

    // private methods

    // override default options with user config
    const extend = function(defaults, userArgs) {
      for (let i in userArgs) {
        defaults[i] = userArgs[i];
      }

      return defaults;
    };

    // update mouse position
    const mouseTrack = function(ev) {
      currX = ev.pageX;
      currY = ev.pageY;
    };

    // check if mouse movement has slowed enough to trigger active state
    const mouseCompare = function(targetElem) {
      const distX = prevX - currX, distY = prevY - currY;
      const distance = Math.sqrt(distX*distX + distY*distY);

      if (distance < config.sensitivity) {
        // if we re-entered an element, cancel delayed exit and clear any active elements immediately
        clearTimeout(exitTimer);
        for (let elem of allElems) {
          if (elem.isActive) {
            config.onExit(elem);
            elem.isActive = false;
          }
        }

        // trigger hover
        config.onEnter(targetElem);
        targetElem.isActive = true;
      } else {
        // update previous coordinates and try again later
        prevX = currX;
        prevY = currY;
        pollTimer = setTimeout(function() {
          mouseCompare(targetElem);
        }, config.interval);
      }
    };

    const init = function(elements, userConfig) {
      if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
        throw 'onEnter and onExit callbacks must be provided';
      }
      config = extend(defaultOptions, userConfig);
      allElems = elements;

      for (let elem of allElems) {
        // holds current element state
        elem.isActive = false;
        // keeps track of mouse position
        elem.addEventListener('mousemove', mouseTrack);

        elem.addEventListener('mouseenter', function(ev) {
          // set initial entry position
          prevX = ev.pageX;
          prevY = ev.pageY;
          // if this element is already active, cancel exit
          if (elem.isActive) {
            clearTimeout(exitTimer);
            return;
          }

          // while mouse is over this element, check distance every 100ms
          pollTimer = setTimeout(function() {
            mouseCompare(elem);
          }, config.interval);
        });
        elem.addEventListener('mouseleave', function(ev) {
          clearTimeout(pollTimer);
          if (!elem.isActive)
            return;

          exitTimer = setTimeout(function() {
            config.onExit(elem);
            elem.isActive = false;
          }, config.exitDelay);
        });
      }
    };

    init(elements, userConfig);
  };

})();
class HeaderDrawer extends HTMLElement {
  constructor() {
    super()
    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      )

    var _this = this;
    this.header = document.getElementById("Header")
    this.headerNav = document.getElementById("HeaderNav")
    this.toggleClick = document.getElementById("Header-toggle")
    this.headerOverlay = document.getElementById("Header-Overlay")
    if (this.toggleClick) {
      this.toggleClick.addEventListener("click", this.toggleHeader.bind(this))
    }
    if (this.headerOverlay) {
      this.headerOverlay.addEventListener(
        "click",
        this.closeMenuDrawer.bind(this)
      )
    }

    // filters
    this.headerMobOpen = document.querySelectorAll(".js-item-open")
    this.headerFilter = document.querySelectorAll(".js-filter-toggle")
    for (let i = 0; i < this.headerMobOpen.length; i++) {
      this.headerMobOpen[i].addEventListener(
        "click",
        this.toggleFilterMobOpen.bind(this)
      )
    }
    for (let i = 0; i < this.headerFilter.length; i++) {
      this.headerFilter[i].addEventListener(
        "click",
        this.toggleFilter.bind(this)
      )
    }
    this.filterType = document.querySelectorAll(".js-filter-type a")
    for (let i = 0; i < this.filterType.length; i++) {
      this.filterType[i].addEventListener("click", this.clickFilter.bind(this))
    }

    this.headerMobToggleItems = document.querySelectorAll(".mobile-item-toggle");
    for (let i = 0; i < this.headerMobToggleItems.length; i++) {
      this.headerMobToggleItems[i].addEventListener("click", function (e) {
        e.preventDefault();
        if (this.nextElementSibling.classList.contains("is-open")) {
          this.nextElementSibling.classList.remove('is-open');
        } else {
          this.nextElementSibling.classList.add('is-open');
        }
      });
    }

    this.headerDesktopMainToggleItems = document.querySelectorAll("li.megamenu");
    this.headerDesktopToggleItems = document.querySelectorAll(".desktop-item-toggle");
    this.headerDesktopMegamenuItems = document.querySelectorAll(".desktop-submenu");
    for (let i = 0; i < this.headerDesktopToggleItems.length; i++) {
      this.headerDesktopToggleItems[i].addEventListener("click", function (e) {
        e.preventDefault();
        for (let i = 0; i < _this.headerDesktopMegamenuItems.length; i++) {
          if (_this.headerDesktopMegamenuItems[i] != this.nextElementSibling) {
            _this.headerDesktopMegamenuItems[i].classList.remove('is-open');
          }
        }
        for (let i = 0; i < _this.headerDesktopToggleItems.length; i++) {
          _this.headerDesktopToggleItems[i].classList.remove('active');
        }
        _this.header.classList.remove('megamenu-open');
        if (this.nextElementSibling.classList.contains("is-open")) {
          this.nextElementSibling.classList.remove('is-open');
          _this.header.classList.remove('megamenu-open');
          this.classList.remove('active');
        } else {
          this.nextElementSibling.classList.add('is-open');
          _this.header.classList.add('megamenu-open');
          this.classList.add('active');
        }
      });
    }

    document.addEventListener("click", function (e) {
      if (!e.target.closest('.megamenu')) {
        for (let i = 0; i < _this.headerDesktopMegamenuItems.length; i++) {
          _this.headerDesktopMegamenuItems[i].classList.remove('is-open');
        }
        for (let i = 0; i < _this.headerDesktopToggleItems.length; i++) {
          _this.headerDesktopToggleItems[i].classList.remove('active');
        }
        _this.header.classList.remove('megamenu-open');
      }
    });



    // var hi = new SV.HoverIntent(_this.headerDesktopMainToggleItems, {
    //       onEnter: function(target) {
    //       var targetItem = target.querySelector(".desktop-item-toggle");

    //    for (let i = 0; i < _this.headerDesktopMegamenuItems.length; i++) {
    //       if (_this.headerDesktopMegamenuItems[i] != this.nextElementSibling) {
    //         _this.headerDesktopMegamenuItems[i].classList.remove('is-open');
    //       }
    //     }
    //     for (let i = 0; i < _this.headerDesktopToggleItems.length; i++) {
    //       _this.headerDesktopToggleItems[i].classList.remove('active');
    //     }
    //     _this.header.classList.remove('megamenu-open');

    //       targetItem.nextElementSibling.classList.add('is-open');
    //       _this.header.classList.add('megamenu-open');
    //       targetItem.classList.add('active');
            
    //       },
    //       onExit: function(target) {
    //          var targetItem = target.querySelector(".desktop-item-toggle");
    //          targetItem.nextElementSibling.classList.remove('is-open');
    //         _this.header.classList.remove('megamenu-open');
    //         targetItem.classList.remove('active');
    //       },
    //       exitDelay: 300,
    //       interval: 100,
    //       sensitivity: 7,
    //     });
    

    this.currentActiveStyle.bind(this)()
  }

  toggleHeader(e) {
    e.preventDefault()
    if (this.header.classList.contains("menu-open")) {
      this.closeMenuDrawer()
    } else {
      this.openMenuDrawer()
    }
  }

  openMenuDrawer() {
    this.header.classList.add("menu-open")
    this.headerNav.classList.add("menu-open")
  }

  closeMenuDrawer() {
    this.header.classList.remove("menu-open")
    this.headerNav.classList.remove("menu-open")
  }

  // filters
  toggleFilter(e) {
    e.preventDefault()
    if (this.header.classList.contains("filter-open")) {
      this.header.classList.remove("filter-open")
      this.headerNav.classList.remove("filter-open")
    } else {
      this.header.classList.add("filter-open")
      this.headerNav.classList.add("filter-open")
    }
  }
  toggleFilterMobOpen(e) {
    e.preventDefault()
    const parent = e.currentTarget.parentNode
    if (parent.classList.contains("is-filter-ul-open")) {
      parent.classList.remove("is-filter-ul-open")
    } else {
      parent.classList.add("is-filter-ul-open")
    }
  }
  clickFilter(e) {
    e.preventDefault()
    const id = e.currentTarget.dataset.id
    const type = e.currentTarget.dataset.type
    const closemenu = e.currentTarget.dataset.closemenu === "true"
    if (closemenu) {
      this.closeMenuDrawer()
    }
    if (window.filters.active[type] === id) return false
    window.filters.active[type] = id
    this.addFilter(type, id, true)
  }
  addFilter(type, id, refresh) {
    if (!id || !type) return
    for (let i = 0; i < this.filterType.length; i++) {
      const el = this.filterType[i]
      const elId = el.dataset.id
      const elType = el.dataset.type
      if (elType === type) {
        if (elId === id) {
          el.classList.add("is-active")
        } else {
          el.classList.remove("is-active")
        }
      }
    }
    if (refresh) {
      this.refreshFilter()
    }
  }
  refreshFilter() {
    let newPathArray = []
    let newPath = ""
    const activeType = window.filters?.active?.type || "all"
    const activeCollection = window.filters?.active?.collection || "all"
    if (activeType != "all") {
      newPathArray.push(activeType)
    }
    if (activeCollection != "all") {
      newPathArray.push(activeCollection)
    }

    newPath = newPathArray.join("+")

    if (window.filters.url) {
      this.renderSectionFromFetch(`${window.filters.url}/${newPath}`)
    } else {
      window.location.href = `/collections/collection/${newPath}`
    }
  }
  currentActiveStyle() {
    this.addFilter("type", window.filters?.active?.type || "all", false)
    this.addFilter(
      "collection",
      window.filters?.active?.collection || "all",
      false
    )
  }

  renderSectionFromFetch(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        const parsedHTML = new DOMParser().parseFromString(html, "text/html")
        this.renderFilters(parsedHTML, url)
        return html
      })
  }

  renderFilters(html, url) {
    const selector = ".collection"
    const itemsElement = html.querySelector(selector)
    if (!itemsElement) return
    document.querySelector(selector).innerHTML = itemsElement.innerHTML
    history.pushState("", "", `${url}`)
  }
}

customElements.define("header-drawer", HeaderDrawer)

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector("input")
    this.changeEvent = new Event("change", { bubbles: true })

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define("quantity-input", QuantityInput)

class Newsletter extends HTMLElement {
  constructor() {
    super()
    this.openDiv = this.querySelector(".newsletter")
    this.popup = this.querySelector(".newsletterpopup")
    this.closeDiv = this.querySelector(".newsletterpopup__close")
    this.overlayDiv = this.querySelector(".newsletterpopup__overlay")

    this.openDiv.addEventListener("click", this.onOpen.bind(this))
    this.closeDiv.addEventListener("click", this.onClose.bind(this))
    this.overlayDiv.addEventListener("click", this.onClose.bind(this))

    const links = document.querySelectorAll("a")
    for (let i = 0; i < links.length; i++) {
      const current = links[i]
      if (current.href.toString().includes("/#open-newsletter")) {
        current.addEventListener("click", this.onOpen.bind(this))
      }
    }
  }

  onOpen(event) {
    event.preventDefault()
    this.openDiv.classList.add("is-open")
    this.popup.classList.add("is-open")
  }
  onClose(event) {
    event.preventDefault()
    this.openDiv.classList.remove("is-open")
    this.popup.classList.remove("is-open")
  }
}

customElements.define("newsletter-component", Newsletter)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options["method"] || "post"
  var params = options["parameters"] || {}

  var form = document.createElement("form")
  form.setAttribute("method", method)
  form.setAttribute("action", path)

  for (var key in params) {
    var hiddenField = document.createElement("input")
    hiddenField.setAttribute("type", "hidden")
    hiddenField.setAttribute("name", key)
    hiddenField.setAttribute("value", params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default")
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default")
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute("data-provinces")
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none"
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option")
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ""
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option")
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class SlidesComponent extends HTMLElement {
  constructor() {
    super()

    this.slider = this.querySelector(".Slides")
    this.sliderItems = this.querySelectorAll(".Slides__item")
    this.currentElement = 0

    if (!this.slider) return
    setInterval(this.nextSlide.bind(this), 4000)
  }

  nextSlide() {
    this.currentElement++

    if (this.currentElement >= this.sliderItems.length) {
      this.currentElement = 0
    }

    for (let i = 0; i < this.sliderItems.length; i++) {
      if (i === this.currentElement) {
        this.sliderItems[i].classList.add("is-active")
      } else {
        this.sliderItems[i].classList.remove("is-active")
      }
    }
  }
}

customElements.define("slides-component", SlidesComponent)

class TabsComponent extends HTMLElement {
  constructor() {
    super()

    this.tabsLinks = this.querySelectorAll(".product__tabs-link")
    this.tabsItems = this.querySelectorAll(".product__tabs-item")
    this.tabsWrap = this.querySelector(".product__tabs-wrap")

    for (let i = 0; i < this.tabsLinks.length; i++) {
      this.tabsLinks[i].addEventListener(
        "click",
        this.handleTabClick.bind(this)
      )
    }
    setTimeout(this.handleResize.bind(this), 1000)
    this.addEventListener("resize", this.handleResize.bind(this))
  }
  handleTabClick(tab) {
    for (let i = 0; i < this.tabsItems.length; i++) {
      if (this.tabsItems[i].dataset.tab === tab.currentTarget.dataset.id) {
        this.tabsItems[i].classList.add("is-active")
        this.tabsLinks[i].classList.add("is-active")
      } else {
        this.tabsItems[i].classList.remove("is-active")
        this.tabsLinks[i].classList.remove("is-active")
      }
    }
  }
  handleResize() {
    let height = 0
    for (let i = 0; i < this.tabsItems.length; i++) {
      const itemheight = this.tabsItems[i].offsetHeight
      if (height < itemheight) {
        height = itemheight
      }
    }
    this.tabsWrap.style.minHeight = height + "px"
  }
}

customElements.define("tabs-component", TabsComponent)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("change", this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, "", false)
    this.removeErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true)
      this.setUnavailable()
    } else {
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  removeErrorMessage() {
    const section = this.closest("section")
    if (!section) return

    const productForm = section.querySelector("product-form")
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html")
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        )
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        if (source && destination) destination.innerHTML = source.innerHTML

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove("visibility-hidden")
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute("disabled", "disabled")
      addButton.style.display = 'none'
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute("disabled")
      addButton.style.display = ''
      addButtonText.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add("visibility-hidden")
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define("variant-selects", VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value
    })
  }
}

customElements.define("variant-radios", VariantRadios)

class BundlePage extends HTMLElement {
  constructor() {
    super()

    this.products = this.querySelectorAll(".card--bundle")
    this.price = 0
    this.active = []
    this.priceDiv = this.querySelector(".bundle-price")
    this.mainDiv = this.querySelector(".page-bundle__main")
    this.submitButton = this.querySelector(".page-bundle-addtocart")

    this.cart = document.querySelector("cart-drawer")

    for (let i = 0; i < this.products.length; i++) {
      const cardmedia = this.products[i].querySelector(".card__media")
      const cardinput = this.products[i].querySelector(".quantity__input")
      if (cardmedia) {
        cardmedia.addEventListener("click", this.selectProduct.bind(this, i))
      }
      if (cardinput) {
        cardinput.addEventListener(
          "change",
          this.changeProductQuantity.bind(this, i)
        )
      }
    }
    this.submitButton.addEventListener("click", this.addToCart.bind(this))
  }
  selectProduct(index) {
    const product = this.products[index]

    if (product.classList.contains("is-active")) {
      this.removeProduct(product)
    } else {
      this.addProduct(product)
    }
  }
  changeProductQuantity(index) {
    const product = this.products[index]
    const qty = parseInt(product.querySelector(".quantity__input")?.value || 1)

    // find product in array and update quantity
    const productIndex = this.active.findIndex(
      (p) => p.id === product.dataset.id
    )
    if (productIndex > -1) {
      this.active[productIndex].quantity = qty
      this.active[productIndex].price = parseFloat(product.dataset.price) * qty
    }
    this.updatePrice()
  }

  removeProduct(product) {
    product.classList.remove("is-active")
    const input = product.querySelector(".quantity__input")
    if (input) {
      input.value = 1
    }
    const productIndex = this.active.findIndex(
      (p) => p.id === product.dataset.id
    )
    if (productIndex > -1) {
      // only splice array when item is found
      this.active.splice(productIndex, 1) // 2nd parameter means remove one item only
    }
    this.updatePrice()
  }
  addProduct(product) {
    product.classList.add("is-active")
    const qty = parseInt(product.querySelector(".quantity__input")?.value || 1)
    const productToAdd = {
      id: product.dataset.id,
      quantity: qty,
      price: parseFloat(product.dataset.price) * qty,
    }
    this.active.push(productToAdd)
    this.updatePrice()
  }

  updatePrice() {
    this.price = 0
    for (let i = 0; i < this.active.length; i++) {
      this.price += this.active[i].price
    }
    if (this.active.length > 0) {
      this.mainDiv.classList.remove("is-hidden")
    } else {
      this.mainDiv.classList.add("is-hidden")
    }
    const priceString = this.price * 0.01

    this.priceDiv.innerHTML = `${window.shopCurrency.replace(
      "{{amount_with_comma_separator}}",
      priceString.toFixed(2)
    )}`
  }
  addToCart(evt) {
    evt.preventDefault()
    if (this.submitButton.getAttribute("aria-disabled") === "true") return
    this.submitButton.setAttribute("aria-disabled", true)
    this.submitButton.classList.add("loading")
    this.querySelector(".spinner").classList.remove("hidden")

    const items = this.active.map((item) => {
      return {
        id: parseInt(item.id),
        quantity: parseInt(item.quantity),
      }
    })

    if (this.cart) {
      this.cart.setActiveElement(document.activeElement)
    }
    const body = JSON.stringify({
      items,
      sections: "cart-drawer,cart-icon-bubble",
    })

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description)

          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message")
          if (!soldOutMessage) return
          this.submitButton.setAttribute("aria-disabled", true)
          this.submitButton.querySelector("span").classList.add("hidden")
          soldOutMessage.classList.remove("hidden")
          this.error = true
          return
        } else if (!this.cart) {
          window.location = window.routes.cart_url
          return
        }

        this.error = false

        this.cart.renderContents(response)
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        this.submitButton.classList.remove("loading")
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty")
        if (!this.error) this.submitButton.removeAttribute("aria-disabled")
        this.querySelector(".spinner").classList.add("hidden")

        this.querySelector(".bundle-success").classList.remove("hidden")
      })
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper")
    if (!this.errorMessageWrapper) return
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message")

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage)

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage
    }
  }
}

customElements.define("bundle-page", BundlePage)

class Accordion extends HTMLElement {
  constructor() {
    super()

    var button = this.querySelector('.accordion-button');
    if (button) {
     button.addEventListener("click", function(event) {
      this.classList.toggle("active");

      var accordionPanel = this.nextElementSibling;
      if (accordionPanel.style.maxHeight) {
        accordionPanel.style.maxHeight = null;
      } else {
        accordionPanel.style.maxHeight = accordionPanel.scrollHeight + "px";
      }
     });
    }
  }
}

customElements.define("custom-accordion", Accordion)

document.addEventListener("DOMContentLoaded", function(event) {
  document.addEventListener("click", function(event) {
    if (event.target.closest('.cart_gift_wrapping_button') || event.target.classList.contains('.cart_gift_wrapping_button')) {
      event.target.closest('.cart_gift_wrapping_button').classList.toggle("active");
   
      var accordionPanel = event.target.closest('.cart_gift_wrapping_button').nextElementSibling;
      if (accordionPanel.style.maxHeight) {
        accordionPanel.style.maxHeight = null;
      } else {
        accordionPanel.style.maxHeight = accordionPanel.scrollHeight + "px";
      }
    }
  });

  var collectionFilterButton = document.querySelector('.collection-filters-button');
  var collectionFilter = document.querySelector('.collection-filters-drawer');
  if (collectionFilterButton != null) {
    collectionFilterButton.addEventListener("click", function(e) {
      this.nextElementSibling.classList.add('is-open');
    });
  }

  document.addEventListener("click", function(event) {
    if (!event.target.closest('.collection-filters-drawer') && !event.target.closest('.collection-filters-button')) {
      if (collectionFilter != null) {
        collectionFilter.classList.remove('is-open');
      }
    }
    if (event.target.closest('.collection-filters-drawer-header-close')) {
      if (collectionFilter != null) {
        collectionFilter.classList.remove('is-open');
      }
    }
  });

  document.addEventListener("change", function(event) {

    if (event.target.id == "CartGiftWrappingCheckbox") {
      var checkbox = event.target;
      checkbox.setAttribute("disabled", true);
      var variantID = checkbox.value;

      if(checkbox.checked != true){
        var cartDrawerItems = document.querySelector("cart-drawer-items");
        if(cartDrawerItems){
          var line =  cartDrawerItems.querySelector(".gift-wrapping-product-selector .quantity__input").getAttribute("data-index");
           cartDrawerItems.updateQuantity(line, 0, "");
           setTimeout(() => {checkbox.removeAttribute("disabled");},200)           
        }        
        
      }else{
      var cartTag = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

        var config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.headers["Content-Type"] = 'application/json';


        var formData = {
            'items': [{
            'id': variantID,
            'quantity': 1
            }]
            };
      
        if (cartTag) {
          formData.sections = cartTag.getSectionsToRender().map((section) => section.id);
        }
        config.body = JSON.stringify(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (!cartTag) {
              window.location = window.routes.cart_url;
              return;
            }

              cartTag.renderContents(response);

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {         
            checkbox.removeAttribute("disabled");
          });

    }
      
    }
  });

  var newsletterPopup = document.querySelector('.newsletter-popup-section');
  if (newsletterPopup != null) {
    if (localStorage.getItem('hideNewsletterPopup') != 'true') {
      newsletterPopup.classList.remove('hide');
    }
  }

  document.addEventListener("click", function(event) {
    if (event.target.classList.contains('newsletter-popup-section-close')) {
      event.target.closest('.newsletter-popup-section').classList.add('hide');
      localStorage.setItem('hideNewsletterPopup', 'true');
    }
  });

  var searchBarClose = document.querySelector('.search-bar-close');
  if (searchBarClose != null) {
    searchBarClose.addEventListener("click", function(event) {
      if (this.closest('.Header__search').querySelector('.desktop-submenu') != null) {
        this.closest('.Header__search').querySelector('.desktop-submenu').classList.remove('is-open');
      }
      if (this.closest('.Header__search').querySelector('.desktop-item-toggle') != null) {
        this.closest('.Header__search').querySelector('.desktop-item-toggle').classList.remove('active');
      }
      if (this.closest('.Header') != null) {
        this.closest('.Header').classList.remove('megamenu-open');
      }
    });
  }

  var announcementSlider = document.querySelector('.announcement-bar-section-slider');
  if (announcementSlider != null) {
    var announcementSliderAutoplay = announcementSlider.getAttribute('data-speed') * 1000;
    var flkty = new Flickity(announcementSlider, {
      // options
      cellAlign: "left",
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: announcementSliderAutoplay
    });
  }
  
});
